// src/routes/ProtectedRoute.tsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { logout } from '../redux/slice/userSlice';
interface ModuleRight {
  right_view: 'Y' | 'N';
  module_url: string;
  module_name: string;
}

const ProtectedRoute = () => {
  // const dispatch = useDispatch();
  // dispatch(logout());
  const isAuthenticated = useSelector((state: any) => state.user.isAuthenticated); // Adjust if needed
  const modules: ModuleRight[] = useSelector((state: any) => state.user?.modules || []);
  const location = useLocation();
  const currentPath = location.pathname.replace(/^\/+/, '').split('/')[0];
  console.log("currentPath == >", currentPath)
  // 🔹 Set page title on route change
  useEffect(() => {
    const permission = modules.find(
      (item) => item.module_url === currentPath
    );

    if (permission?.module_name) {
      document.title = permission.module_name;
    } else if (currentPath === 'profile') {
      document.title = 'Profile';
    } else if (currentPath === 'change-password') {
      document.title = 'Change Password';
    } else if (currentPath === 'measurement') {
      document.title = 'Measurement';
    } else if (currentPath === 'add-body-shape') {
      document.title = 'Body Shape';
    } else if (currentPath === 'last-step-measurment') {
      document.title = 'Measurement';
    } else {
      document.title = 'My App'; // fallback
    }
  }, [currentPath, modules]);
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // const permission = modules.find((item) => item.module_url === currentPath);
  const permission = modules.find((item) => {
    const moduleUrl = item.module_url.split('?')[0]; // remove query params
    const path = currentPath.split('?')[0]; // remove query params from current path too
    return moduleUrl === path;
  });
  console.log(currentPath);
  // console.log(permission);
  console.log("currentPath -- ", currentPath);
  // console.log("permission",permission);
  // console.log("modules",modules);
  // ✅ Allow access only if right_view === 'Y'

  if ((!permission || permission.right_view !== 'Y') && currentPath !== 'change-password' && currentPath !== 'profile' && currentPath !== 'last-step-measurment' && currentPath !== 'add-body-shape' && currentPath !== 'pending-jobs' && currentPath !== 'measurement' && currentPath !== 'self-napi' && currentPath !== 'return-napi') {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }


  return <Outlet />;
};

export default ProtectedRoute;
